/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGasstation = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15 1v7.1a5.01 5.01 0 0 1 4 4.9v4a1.001 1.001 0 0 0 2 0V7c0-2.206-1.794-4-4-4V1c3.309 0 6 2.691 6 6v10c0 1.654-1.346 3-3 3s-3-1.346-3-3v-4a3.006 3.006 0 0 0-2-2.829v5.224c0 2.161.634 4.252 1.832 6.05A1 1 0 0 1 16 23H2c-.368 0-.707-.203-.882-.528a1.004 1.004 0 0 1 .05-1.027A10.867 10.867 0 0 0 3 15.395V1zm-2 9H5v5.395c0 1.956-.438 3.864-1.28 5.605h10.56A12.86 12.86 0 0 1 13 15.395zm0-7H5v5l8-.001z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGasstation as Gasstation };
